<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
@if (isCnUser && restrictGlobalUIChanges) {
  <profile-pds-p-inline-notification
    p-inline-notification
    class="profile:w-full profile:md:w-1/2 profile:mt-fluid-md profile:md:mt-0"
    [dismissButton]="false"
    description="{{ 'pidpaw.cnViewOrEditRestrictionDisclaimer.message' | translate }}"
  >
  </profile-pds-p-inline-notification>
} @else {
  @if (mode === MyprofileBirthdayWidgetMode.PROFILE) {
    <div class="profile:flex profile:flex-col">
      <div>
        @if (formattedDate) {
          <profile-pds-p-text p-text size="inherit" class="profile:text-[20px]">
            <div class="fs-exclude" [innerHTML]="formattedDate"></div>
          </profile-pds-p-text>
        }
      </div>
      @if (formattedDate) {
        <div class="profile:flex profile:flex-row profile:gap-x-static-md">
          <div>
            <profile-pds-p-button-pure
              [aria]="{ 'aria-label': ('birthdayWidget.button.edit.labelA11y' | translate) }"
              p-button-pure
              class="profile:py-fluid-sm"
              icon="edit"
              id="editBtn-profile"
              (click)="triggerEdit()"
              [myprofileUiTrack]="{
                clickElementType: 'button',
                clickElementId: 'date_of_birth',
                clickElementName: 'edit',
              }"
            >
              {{ editButtonLabel }}
            </profile-pds-p-button-pure>
          </div>
          <div>
            <profile-pds-p-button-pure
              [aria]="{
                'aria-label': ('birthdayWidget.button.delete.labelA11y' | translate),
                'aria-haspopup': 'dialog',
              }"
              p-button-pure
              icon="delete"
              class="profile:py-fluid-sm"
              id="deleteBirthdateBtn"
              (click)="triggerDelete()"
              [myprofileUiTrack]="{
                clickElementType: 'button',
                clickElementId: 'date_of_birth',
                clickElementName: 'delete',
              }"
            >
              {{ deleteButtonLabel }}
            </profile-pds-p-button-pure>
          </div>
        </div>
      }
      <div>
        @if (!formattedDate) {
          <profile-pds-p-text p-text size="sm">
            <div id="birthday-no-date-hint" class="fs-exclude" [innerHTML]="noDateLabel"></div>
          </profile-pds-p-text>
        }
      </div>
    </div>
  }
  @if (mode !== MyprofileBirthdayWidgetMode.PROFILE) {
    <div class="profile:flex profile:flex-col profile:md:flex-row">
      <div class="profile:grow">
        @if (formattedDate) {
          <profile-pds-p-text p-text size="inherit">
            <div class="fs-exclude" [innerHTML]="formattedDate"></div>
          </profile-pds-p-text>
        }
        @if (!formattedDate) {
          <profile-pds-p-text p-text size="sm">
            <div id="birthday-no-date-hint" class="fs-exclude" [innerHTML]="noDateLabel"></div>
          </profile-pds-p-text>
        }
      </div>
      @if (formattedDate) {
        <div>
          <profile-pds-p-button-pure
            [aria]="{ 'aria-label': ('birthdayWidget.button.edit.labelA11y' | translate) }"
            p-button-pure
            icon="edit"
            (click)="triggerEdit()"
            class="profile:p-0 profile:mt-fluid-md profile:md:mt-0"
            id="editBtn-external"
            [myprofileUiTrack]="{
              clickElementType: 'button',
              clickElementId: 'date_of_birth',
              clickElementName: 'edit',
            }"
          >
            {{ editButtonLabel }}
          </profile-pds-p-button-pure>
        </div>
      }
    </div>
  }
}
